export const isProductionEnvironment = (): boolean => {
  return import.meta.env.VITE_ENV === 'production';
};

export const getEnvironmentName = (): string => {
  const env = import.meta.env.VITE_ENV || 'production';
  return env === 'production' ? 'PRODUCTION' : `Test (${env})`;
};
